export default __webpack_public_path__ + "static/media/showsdb-logo-white.2b452bba.png";